<template>
  <!-- 鼠标移入 NO 列的“辅料”标识后展示已带回的辅料详情 -->
  <el-popover placement="left" width="360" trigger="hover" popper-class="material-mark-popper">
    <!-- 详情直接使用标识操作从辅料列表带回的数据，不额外请求接口 -->
    <div class="material-tip"
      style="min-width:0;min-height:160px;padding:12px 16px;border:1px solid #dcdfe6;border-radius:6px;background-color:#fff;box-sizing:border-box;">
      <div class="material-id"
        style="color:#606266;font-size:14px;line-height:19px;">
        {{ $t('message.materialId') }}：{{ detail.id || materialId }}
      </div>
      <div style="display:flex;margin-top:10px;">
        <!-- 辅料主图，支持点击预览原图 -->
        <div class="material-image"
          style="flex:0 0 96px;width:96px;height:96px;margin-right:12px;border-radius:4px;background-color:#9b9b9b;overflow:hidden;">
          <el-image v-if="detail.main_image" :src="detail.main_image" fit="cover"
            :preview-src-list="[detail.main_image]" style="display:block;width:100%;height:100%;" />
        </div>
        <!-- 辅料名称、类型、补货状态和实际库存 -->
        <div class="material-content"
          style="flex:1;min-width:0;color:#606266;font-size:12px;">
          <!-- 名称点击后在新标签打开辅料详情 -->
          <router-link class="material-name" :to="detailLink" target="_blank" @click.native.stop
            style="display:block;margin-bottom:8px;color:#303133;line-height:18px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
            {{ detail.name_trans }}
          </router-link>
          <div class="stock-status"
            :style="{ marginBottom: '8px', color: stockStatusColor(detail), fontWeight: 'bold', lineHeight: '18px' }">
            {{ stockStatusText(detail) }}
          </div>
          <div class="material-type" style="margin-bottom:6px;line-height:18px;">
            {{ detail.type_name || (detail.type && detail.type.name) }}
          </div>
          <div class="stock-row" style="margin-bottom:6px;line-height:18px;white-space:nowrap;">
            {{ $t('message.actualStockQuantity') }}：{{ detail.material_stock_num }}
          </div>
        </div>
      </div>
    </div>
    <!-- NO 列展示的辅料标识，鼠标悬停触发 Tips -->
    <el-tag slot="reference" class="material-mark" size="mini">
      {{ $t('message.auxiliaryMaterials') }}
    </el-tag>
  </el-popover>
</template>

<script>
/**
 * 商品辅料标识 Tips。
 * detail 字段直接对应辅料列表项：id、main_image、name_trans、type_name、
 * material_stock_num、pre_consume_num、pre_up_num。
 */
export default {
  name: 'MaterialMarkTip',
  props: {
    // 详情页跳转使用的辅料 ID
    materialId: {
      default: ''
    },
    // 详情页跳转使用的客户 ID
    userId: {
      default: ''
    },
    // 标识时由辅料列表直接带回的完整数据
    detail: {
      default: () => ({})
    }
  },
  computed: {
    // 使用父页面传入的辅料 ID 和客户 ID 生成详情页地址
    detailLink() {
      return {
        path: '/materialDetail',
        query: {
          id: this.materialId,
          user_id: this.userId
        }
      }
    }
  },
  methods: {
    // 实际库存为 0 时优先判定为无库存
    isOutOfStock(item) {
      return Number(item.material_stock_num || 0) === 0
    },
    // 实际库存低于预计消耗量时判定为库存不足
    isStockInsufficient(item) {
      return Number(item.material_stock_num || 0) < Number(item.pre_consume_num || 0)
    },
    // 按“无库存 > 库存不足 > 建议补货 > 库存充足”的优先级展示状态
    stockStatusText(item) {
      if (this.isOutOfStock(item)) return this.$t('message.noStock')
      if (this.isStockInsufficient(item)) return this.$t('message.stockInsufficient')
      if (Number(item.pre_up_num || 0) > 0) return this.$t('message.suggestReplenishment')
      return this.$t('message.stockSufficient')
    },
    // 状态颜色与文案判断保持一致：异常为红色、待补货为橙色、正常为绿色
    stockStatusColor(item) {
      if (this.isOutOfStock(item) || this.isStockInsufficient(item)) return '#c8383e'
      if (Number(item.pre_up_num || 0) > 0) return '#e6a23c'
      return '#15ad3c'
    }
  }
}
</script>

<style lang="scss" scoped>
.material-mark {
  height: 22px;
  padding: 0 6px;
  border: 0;
  border-radius: 2px;
  background-color: #67c23a;
  color: #fff;
  line-height: 22px;
  cursor: pointer;
}

</style>
